import { Layout, Menu } from 'element-react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from 'react';
import { myStoreMenuItems } from '../utils/MenuMyStoreCatalogs';
import menuStore from '../store/menu-selected';
import { Auth } from 'aws-amplify';
import { listCompanys } from '../graphql/queries';
import PagerQuery from '../utils/PagerQuery';

const MyStoreLeftMenu = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const { menuIndex, setMenuIndex } = menuStore();
    const [isSticky, setIsSticky] = useState(false);
    const [isCompanyPublished, setIsCompanyPublished] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollThreshold = 130;
            setIsSticky(window.scrollY > scrollThreshold);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Consulta ligera para saber si la empresa está publicada
    useEffect(() => {
        const checkCompanyPublished = async () => {
            try {
                const user = await Auth.currentAuthenticatedUser();
                const pagerQuery = new PagerQuery(listCompanys, { filter: { owner: { eq: user.username } } }, Object.keys({ listCompanys }));
                const result = await pagerQuery.searchPrivateData();
                const items = result.data.listCompanys.items;
                if (items.length > 0 && items[0].published === 1) {
                    setIsCompanyPublished(true);
                }
            } catch (e) {
                console.error("MyStoreLeftMenu: Error checking company status", e);
            }
        };
        checkCompanyPublished();
    }, []);

    // Filtramos los items del menú para ocultar Verification Tools si no está publicada
    const getFilteredMenuItems = () => {
        return myStoreMenuItems.admin.map(item => {
            if (item.submenu) {
                return {
                    ...item,
                    submenu: item.submenu.filter(sub => {
                        // Ocultar /company-verification si la empresa no está publicada
                        if (sub.linkTo === '/company-verification' && !isCompanyPublished) {
                            return false;
                        }
                        return true;
                    })
                };
            }
            return item;
        });
    };

    function createMenuItems(items) {
        return items.map((item) => {
            let clazzName = menuIndex === item.linkTo ? "cursor menu-selected" : "cursor";

            if (item.submenu) {
                return (
                    <Menu.SubMenu index={item.label} title={<label className="menu1-title menu2-title">{t(item.label)}</label>} key={item.label}>
                        {createMenuItems(item.submenu)}
                    </Menu.SubMenu>
                );
            } else {
                return (
                    <div key={item.linkTo} onClick={() => { setMenuIndex(item.linkTo); history.push(item.linkTo); }}>
                        <Menu.Item className="menu1-title" index={item.linkTo}><label className={clazzName}>{t(item.label)}</label></Menu.Item>
                    </div>
                );
            }
        });
    }

    return (
        <Layout.Row className={`tac main-left-menu seller-menu ${isSticky ? 'menu-is-sticky' : ''}`}>
            <Layout.Col span={24}>
                <div className="sidenav">
                    <Menu defaultActive={menuIndex} className="el-menu-vertical-demo">
                        <Menu.Item uniqueOpened={true} index="" className="left-menu-title">
                            {'SELLER HUB'}
                        </Menu.Item>
                        {createMenuItems(getFilteredMenuItems())}
                    </Menu>
                </div>
            </Layout.Col>
        </Layout.Row>
    );
}

export default MyStoreLeftMenu;